// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionF_TheComp__kTfvn"};